/* global axios */
import ApiClient from '../ApiClient';

class AiBotIntentDecisionsAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/intent_decisions`, { accountScoped: true });
  }

  get({ page, route, answered_by, feedback, max_confidence, lost, from, to }) {
    return axios.get(this.url, {
      params: {
        page,
        route,
        answered_by,
        feedback,
        max_confidence,
        lost,
        from,
        to,
      },
    });
  }

  stats({ from, to } = {}) {
    return axios.get(`${this.url}/stats`, { params: { from, to } });
  }

  feedback(id, { feedback, feedback_route, feedback_note }) {
    return axios.post(`${this.url}/${id}/feedback`, {
      feedback,
      feedback_route,
      feedback_note,
    });
  }
}

export default AiBotIntentDecisionsAPI;
